import {
    getAuthors,
    deleteAuthor,
    getShowAuthor,
    updateAuthor,
    createAuthor,
    getSocialNetworks
} from '../../api/authorsApi'
import {Message} from "element-ui";
import router from "../../router";

const state = {
    authors: [],
    author: {},
    socialNetworks: []
}

const getters = {
    getAuthors: state => state.authors,
    getShowAuthor: state => state.author,
    getSocialNetworks: state => state.socialNetworks
}

const mutations = {
    SET_AUTHORS: (state, payload) => {
        state.authors = payload.data
    },
    SET_AUTHOR_SHOW: (state, payload) => {
        state.author = payload
    },
    SET_SOCIAL_NETWORKS: (state, payload) => {
        state.socialNetworks = payload
    }
}

const actions = {
    getAuthors: ({commit}, params) => {
        getAuthors(params).then(resp => {
            commit('SET_AUTHORS', resp)
        }).catch(err => console.log(err))
    },
    deleteAuthor: ({dispatch}, id) => {
        deleteAuthor(id).then(r => {
            Message({
                message: 'Author has been deleted',
                type: 'success',
                duration: 5 * 1000,
                showClose: true,
            })
        })
    },
    getShowAuthor: ({commit, dispatch}, idAuthor) => {
        getShowAuthor(idAuthor).then(r => {
            getSocialNetworks().then(r => {
                commit('SET_SOCIAL_NETWORKS', r.data)
            }).catch(err => {
                if (err.response.status === 404) {
                    console.log(router.push({name: 'not-found'}))
                }
            })
            commit('SET_AUTHOR_SHOW', r.data)
        }).catch(err => {
            if (err.response.status === 404) {
                console.log(router.push({name: 'not-found'}))
            }
        })
    },
    updateAuthor: ({commit}, payload) => {
        updateAuthor(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    createAuthor: ({commit}, payload) => {
        createAuthor(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    clearCurrentAuthor: ({commit}) => {
        getSocialNetworks().then(r => {
            commit('SET_SOCIAL_NETWORKS', r.data)
        }).catch(err => {
            if (err.response.status === 404) {
                console.log(router.push({name: 'not-found'}))
            }
        })
        commit('SET_AUTHOR_SHOW')
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
